import logo from './MT-LOGO 2.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img className='logo' src={logo} alt="logo" />
        <h3>
          MilliyTizim.uz - ta'lim platformasi
        </h3>
          <span>Bog'lanish <a href='https://t.me/milliybro'>@MilliyBro</a></span>  
      </header>
    </div>
  )
}

export default App;
